import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from './components/AppShell';
import { AuthProvider, useAuth } from './lib/auth';
import { AeoPagesList } from './routes/AeoPagesList';
import { AuthCallback } from './routes/AuthCallback';
import { EventsFeed } from './routes/EventsFeed';
import { LeadDetail } from './routes/LeadDetail';
import { LeadsList } from './routes/LeadsList';
import { RevenuePage } from './routes/RevenuePage';
import { SignIn } from './routes/SignIn';
import { ToolDetail } from './routes/ToolDetail';
import { ToolsList } from './routes/ToolsList';

function Gate({ children }: { children: React.ReactNode }) {
  const { loading, authorized } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="inline-flex items-center gap-3 text-[13px] text-foreground/55">
          <span className="inline-block h-3 w-3 rounded-full border-2 border-foreground/20 border-t-gold animate-spin" />
          Loading…
        </div>
      </div>
    );
  }
  return authorized ? <>{children}</> : <Navigate to="/signin" replace />;
}

export function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/signin" element={<SignIn />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route
            element={
              <Gate>
                <AppShell />
              </Gate>
            }
          >
            <Route index element={<Navigate to="/tools" replace />} />
            <Route path="/tools" element={<ToolsList />} />
            <Route path="/tools/:slug" element={<ToolDetail />} />
            <Route path="/revenue" element={<RevenuePage />} />
            <Route path="/leads" element={<LeadsList />} />
            <Route path="/leads/:id" element={<LeadDetail />} />
            <Route path="/events" element={<EventsFeed />} />
            <Route path="/aeo" element={<AeoPagesList />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
